<div class="stepper-container">
  <mat-stepper   [linear]="true" (selectionChange)="onStepChange($event)" #stepper>
      <mat-step [stepControl]="signatureStepForm">
          <ng-template matStepperIcon="edit">
              <mat-icon class="icon-display">check</mat-icon>
           
            </ng-template>
              <ng-template matStepLabel>Signatures</ng-template>
              <div>
                <app-signature-form #SignatureFormComponent></app-signature-form>
              </div>
      </mat-step>
      <mat-step [stepControl]="selectUserType">
          <ng-template matStepperIcon="edit">
              <mat-icon class="icon-display">check</mat-icon>
           
            </ng-template>
        
              <ng-template matStepLabel>User Type</ng-template>
             <div>
              <div class="step-content" style="align-items: center;">
                <div class="step-title">
                    <div class="Label" style="color: rgba(0, 0, 0, 0.87); font-size: 24px; font-family: Roboto; font-weight: 400; line-height: 32.02px; word-wrap: break-word">Select user type</div>
                </div>
            <form [formGroup]="selectUserType">
                <ng-template matStepLabel>User Type</ng-template>
                <mat-radio-group formControlName="userType"  aria-label="Select an option">
                   
                    
                   
              <div class="row">
             
                <div style="cursor: pointer;" (click)="onSelectCard('1')"  [ngClass]="{'column-card-types': registerAs != '4' ,'column-card': registerAs != '1' ,'column-card-selected': registerAs == '1'   }">
          <div class="column-card-body">
            <div class="column-card-body-content">
              <div [ngClass]="{'column-card-title-blue': registerAs != '1' ,'column-card-title-white': registerAs == '1'   }">
                <div style="align-self: stretch; justify-content: flex-start; align-items: flex-start; gap: 8px; display: inline-flex">
                  <div style="width: 32px; height: 32px; position: relative">
                    <mat-icon >person</mat-icon>
                  </div>
                </div>
                <div style="align-self: stretch;  font-size: 15px; font-family: Roboto; font-weight: 500; text-transform: uppercase; line-height: 26px; letter-spacing: 0.46px; word-wrap: break-word">Individual property owner</div>
              </div>
              <div style="width: 24px; height: 24px; position: relative">
                <div style="width: 20px; height: 20px; left: 2px; top: 2px; position: absolute;">
                  <mat-radio-button class="matselectcard" [checked]="registerAs == '1'" (change)="radioChange($event)" color="primary"  value="1">
                  </mat-radio-button>
                </div>
              </div>
            </div>
            <div style="align-self: stretch; justify-content: flex-start; align-items: center; gap: 8px; display: inline-flex">
              <div class="column-card-footer-title">You are the property owner and want to create an account to validate tax info or manage taxes by yourself.</div>
            </div>
          </div>
          </div>
          <div style="cursor: pointer;" (click)="onSelectCard('2')"  [ngClass]="{'column-card-types': registerAs != '4' ,'column-card': registerAs != '2' ,'column-card-selected': registerAs == '2'   }">
            <div class="column-card-body">
                <div class="column-card-body-content">
              <div [ngClass]="{'column-card-title-blue': registerAs != '2' ,'column-card-title-white': registerAs == '2'   }">
                <div style="align-self: stretch; justify-content: flex-start; align-items: flex-start; gap: 8px; display: inline-flex">
                  <div style="width: 32px; height: 32px; position: relative">
                    <mat-icon >location_city</mat-icon>
                  </div>
                </div>
                <div style="align-self: stretch;  font-size: 15px; font-family: Roboto; font-weight: 500; text-transform: uppercase; line-height: 26px; letter-spacing: 0.46px; word-wrap: break-word">Property management company</div>
              </div>
              <div style="width: 24px; height: 24px; position: relative">
                <div style="width: 20px; height: 20px; left: 2px; top: 2px; position: absolute;">
                  <mat-radio-button class="matselectcard"[checked]="registerAs == '2'" (change)="radioChange($event)" color="primary"  value="2">
                  </mat-radio-button>
                </div>
              </div>
            </div>
            <div style="align-self: stretch; justify-content: flex-start; align-items: center; gap: 8px; display: inline-flex">
              <div class="column-card-footer-title">This category is suitable for companies responsible for maintaining properties, collecting rent, and handling tenant relations on behalf of property owners.</div>
            </div>
          </div>
          </div>
          
          <div style="cursor: pointer;" (click)="onSelectCard('3')"   [ngClass]="{'column-card-types': registerAs != '4' ,'column-card': registerAs != '3' ,'column-card-selected': registerAs == '3'   }">
            <div class="column-card-body">
                <div class="column-card-body-content">
              <div [ngClass]="{'column-card-title-blue': registerAs != '3' ,'column-card-title-white': registerAs == '3'   }">
                <div style="align-self: stretch; justify-content: flex-start; align-items: flex-start; gap: 8px; display: inline-flex">
                  <div style="width: 32px; height: 32px; position: relative">
                    <mat-icon>hotel</mat-icon>
                  </div>
                </div>
                <div style="align-self: stretch; font-size: 15px; font-family: Roboto; font-weight: 500; text-transform: uppercase; line-height: 26px; letter-spacing: 0.46px; word-wrap: break-word">Bed & breakfast / Hotel / Motel</div>
              </div>
              <div style="width: 24px; height: 24px; position: relative">
                <div style="width: 20px; height: 20px; left: 2px; top: 2px; position: absolute;">
                  <mat-radio-button class="matselectcard"[checked]="registerAs == '3'" (change)="radioChange($event)" color="primary" value="3">
                  </mat-radio-button>
                </div>
              </div>
            </div>
            <div style="align-self: stretch; justify-content: flex-start; align-items: center; gap: 8px; display: inline-flex">
              <div class="column-card-footer-title">Select this option if you  that provides lodging services. This category is ideal for businesses offering short-term accommodations.</div>
            </div>
          </div>
          
          </div>
              </div>
           
              </mat-radio-group>
              </form>
            </div>
             </div>
 
         
      </mat-step>
      <mat-step [stepControl]="getFormGroup()" >
          <ng-template matStepperIcon="edit">
              <mat-icon class="icon-display">check</mat-icon>
           
            </ng-template>
       
              <ng-template matStepLabel>{{getStepDescription()}}</ng-template>
              <div   *ngIf="registerAs  == '1'" class="step-content-form">

  
                <div class="step-body">
                    <div class="row">
                        <label class="label-icon">
                          <mat-icon>person</mat-icon>
                          <span>INDIVIDUAL PROPERTY OWNER</span>
                      </label>
                      </div>
                      <div class="Frame32" style="width: 100%; height: 100%;padding-top: 1rem; padding-bottom: 1rem; flex-direction: column; justify-content: flex-start; align-items: center; gap: 32px; display: inline-flex">
                        <div class="Formlabel" style="flex-direction: column; justify-content: flex-start; align-items: flex-start; display: flex">
                        <div class="Label" style="text-align: center; color: rgba(0, 0, 0, 0.87); font-size: 24px; font-family: Roboto; font-weight: 400; line-height: 32.02px; word-wrap: break-word">{{getStepDescription()}}</div>
                        </div>
                        </div>
                <form [formGroup]="ownerForm">
              <div class="controls-container">
            
            
                    <div class="row">
                
                  <mat-form-field class="mat-form-field-100"  appearance="outline">
                    <mat-label style="font-size: 16px !important;">First Name</mat-label>
                    <input matInput formControlName="firstName" placeholder="First Name"> 
                    <mat-error *ngIf="this.ownerForm.get('firstName')?.errors?.['required'] && (ownerForm.get('firstName')?.touched)">First Name is required</mat-error>
                  </mat-form-field>
                  </div>
            
            
                  <div class="row">
                
                    <mat-form-field class="mat-form-field-100"  appearance="outline">
                      <mat-label style="font-size: 16px !important;">Last Name</mat-label>
                      <input matInput formControlName="lastName" placeholder="Last Name"
                      required> 
                      <mat-error>Last Name is required</mat-error>
                    </mat-form-field>
                    </div>
                    <div class="row">
                      <mat-form-field  class="mat-form-field-100" appearance="outline">
                        <mat-label style="font-size: 16px !important;">Email Address</mat-label>
                        <input required matInput formControlName="email" placeholder="Email Address"
                               >
                               <mat-error *ngIf="this.ownerForm.get('email')?.errors?.['required'] && (ownerForm.get('email')?.touched)">Email Address is required</mat-error>
                               <mat-error *ngIf="this.ownerForm.get('email')?.errors?.['email'] && (ownerForm.get('email')?.touched && ownerForm.get('email')?.value)">Email Address is Invalid</mat-error>
                      </mat-form-field>
                    </div>
            
                    <div class="row">
                      <mat-form-field  class="mat-form-field-100" appearance="outline" >
                        <mat-label style="font-size: 16px !important;">Phone Number</mat-label>
                        <input matInput formControlName="phoneNumber" placeholder="Phone Number"
                               >
                               <mat-error  *ngIf="this.ownerForm.get('phoneNumber')?.errors?.['required'] && (ownerForm.get('phoneNumber')?.touched)">Phone Number is required</mat-error>
                               <mat-error *ngIf="this.ownerForm.get('phoneNumber')?.errors?.['pattern'] && (ownerForm.get('phoneNumber')?.touched && ownerForm.get('phoneNumber')?.value)">Phone Number is Invalid</mat-error>
                              </mat-form-field>
              
                    </div>
                </div>
                </form>
                </div>
                
                
                </div>
                <div   *ngIf="registerAs == '2'" class="step-content-form">

  
                  <div class="step-body">
                      <div class="row">
                          <label class="label-icon">
                              <mat-icon>business</mat-icon>
                              <span>PROPERTY MANAGEMENT COMPANY</span>
                        </label>
                        </div>
                        <div class="Frame32" style="width: 100%; height: 100%;padding-top: 1rem; padding-bottom: 1rem; flex-direction: column; justify-content: flex-start; align-items: center; gap: 32px; display: inline-flex">
                          <div class="Formlabel" style="flex-direction: column; justify-content: flex-start; align-items: flex-start; display: flex">
                          <div class="Label" style="text-align: center; color: rgba(0, 0, 0, 0.87); font-size: 24px; font-family: Roboto; font-weight: 400; line-height: 32.02px; word-wrap: break-word">Main info</div>
                          </div>
                          </div>
                  <form  *ngIf="registerAs == '2'"  [formGroup]="managementCompany">
                <div class="controls-container">
              
              
                  <div class="row">
                  
                      <mat-form-field class="mat-form-field-100"  appearance="outline">
                        <input matInput formControlName="businessLegalName" placeholder="Business Legal name"> 
                        <mat-error>Business Legal name is required</mat-error>
                      </mat-form-field>
                      </div>
              
                      <div class="row">
                  
                          <mat-form-field class="mat-form-field-100"  appearance="outline">
                            <input matInput formControlName="businessDBAname" placeholder="Business DBA name"
                            required> 
                          </mat-form-field>
                          </div>
              
                      <div class="row">
                  
                    <mat-form-field class="mat-form-field-100"  appearance="outline">
                      <input matInput formControlName="primaryContactFirstName" placeholder="Primary Contact First Name"
                      required> 
                      <mat-error>Primary Contact First Name is required</mat-error>
                    </mat-form-field>
                    </div>
              
              
                    <div class="row">
                  
                      <mat-form-field class="mat-form-field-100"  appearance="outline">
                        <input matInput formControlName="primaryContactLastName" placeholder="Primary Contact Last Name"
                        required> 
                        <mat-error>Primary Contact Last Name is required</mat-error>
                      </mat-form-field>
                      </div>
                      <div class="row">
                        <mat-form-field  class="mat-form-field-100" appearance="outline">
                          <mat-label style="font-size: 16px !important;">Primary Contact Email Address</mat-label>
                          <input required matInput formControlName="primaryContactEmail" placeholder="Primary Contact Email Address"
                                 >
                                 <mat-error *ngIf="this.managementCompany.get('primaryContactEmail')?.errors?.['required'] && (managementCompany.get('primaryContactEmail')?.touched)">Email Address is required</mat-error>
                                 <mat-error *ngIf="this.managementCompany.get('primaryContactEmail')?.errors?.['pattern'] && (managementCompany.get('primaryContactEmail')?.touched && managementCompany.get('primaryContactEmail')?.value)">Email Address is Invalid</mat-error>
                        </mat-form-field>
                      </div>
              
                      <div class="row">
                        <mat-form-field  class="mat-form-field-100" appearance="outline" >
                          <mat-label style="font-size: 16px !important;">Primary Contact Phone Number</mat-label>
                          <input matInput formControlName="primaryContactPhoneNumber" placeholder="Primary Contact Phone Number"
                                 >
                                 <mat-error  *ngIf="this.managementCompany.get('primaryContactPhoneNumber')?.errors?.['required'] && (managementCompany.get('primaryContactPhoneNumber')?.touched)">Phone Number is required</mat-error>
                                 <mat-error *ngIf="this.managementCompany.get('primaryContactPhoneNumber')?.errors?.['pattern'] && (managementCompany.get('primaryContactPhoneNumber')?.touched && managementCompany.get('primaryContactPhoneNumber')?.value)">Phone Number is Invalid</mat-error>
                                </mat-form-field>
                
                      </div>
                  </div>
                  </form>
                  </div>
                  
                  
                  </div>

                  <div  *ngIf="registerAs != '1' && registerAs != '2'" class="step-content-form">

  
                    <div class="step-body">
                        <div class="row" style="justify-content: center;">
                            <label class="label-icon">
                                <p> <mat-icon style="color: #2196F3;">hotel</mat-icon></p>
                                <span>BED & BREAKFAST/ HOTEL / MOTEL</span>
                            </label>
                             
                          </div>
                          <div class="Frame32" style="width: 100%; height: 100%;padding-top: 1rem; padding-bottom: 1rem; flex-direction: column; justify-content: flex-start; align-items: center; gap: 32px; display: inline-flex">
                            <div class="Formlabel" style="flex-direction: column; justify-content: flex-start; align-items: flex-start; display: flex">
                            <div class="Label" style="text-align: center; color: rgba(0, 0, 0, 0.87); font-size: 24px; font-family: Roboto; font-weight: 400; line-height: 32.02px; word-wrap: break-word">Main info</div>
                            </div>
                            </div>
                    <form [formGroup]="hotelMotel">
                  <div class="controls-container">
                
                    <div class="row">
                  
                       
                      <div class="column">
                      
                          <mat-form-field class="mat-form-field-100"  appearance="outline">
                            <input matInput formControlName="personNameOrCompanyName" placeholder="Person name Or Company name"
                            required> 
                            <mat-error>Person name Or Company name</mat-error>
                          </mat-form-field>
                          </div>
                          </div>
                    <div class="row">
                  
                       
                    <div class="column">
                    
                        <mat-form-field class="mat-form-field-100"  appearance="outline">
                          <input matInput formControlName="primaryContactFirstName" placeholder="Primary contact first name"
                          required> 
                          <mat-error>Primary contact first name is required</mat-error>
                        </mat-form-field>
                        </div>
                        </div>
                
                        <div class="row">
                           
                               
                            <div class="column">
                            
                                <mat-form-field class="mat-form-field-100"  appearance="outline">
                                  <input matInput formControlName="primaryContactLastName" placeholder="Primary contact last name"
                                  required> 
                                  <mat-error>Primary contact last name is required</mat-error>
                                </mat-form-field>
                                </div>
                                </div>
                                <div class="row">
                               
                                  
                                       
                                    <div class="column">
                                    
                                        <mat-form-field  class="mat-form-field-100" appearance="outline">
                                            <mat-label style="font-size: 16px !important;">Primary contact email address</mat-label>
                                            <input required matInput formControlName="primaryContactEmail" placeholder="Primary contact email address"
                                                   >
                                                   <mat-error *ngIf="this.hotelMotel.get('primaryContactEmail')?.errors?.['required'] && (hotelMotel.get('primaryContactEmail')?.touched)">Email address is required</mat-error>
                                                   <mat-error *ngIf="this.hotelMotel.get('primaryContactEmail')?.errors?.['pattern'] && (hotelMotel.get('primaryContactEmail')?.touched && hotelMotel.get('primaryContactEmail')?.value)">Email address is invalid</mat-error>
                                          </mat-form-field>
                                        </div>
                                </div>
                
                 
                
                                <div class="row">
                                 
                                  
                                       
                                    <div class="column">
                                    
                                        <mat-form-field  class="mat-form-field-100" appearance="outline" >
                                            <mat-label style="font-size: 16px !important;">Primary Contact Phone Number</mat-label>
                                            <input matInput formControlName="primaryContactPhoneNumber" placeholder="Primary contact phone number"
                                                   >
                                                   <mat-error  *ngIf="this.hotelMotel.get('primaryContactPhoneNumber')?.errors?.['required'] && (hotelMotel.get('primaryContactPhoneNumber')?.touched)">Phone Number is required</mat-error>
                                                   <mat-error *ngIf="this.hotelMotel.get('primaryContactPhoneNumber')?.errors?.['pattern'] && (hotelMotel.get('primaryContactPhoneNumber')?.touched && hotelMotel.get('primaryContactPhoneNumber')?.value)">Phone Number is Invalid</mat-error>
                                                  </mat-form-field>
                                        </div>
                                </div>
                
                
                    </div>
                    </form>
                    </div>
                    
                    
                    </div>
                               
      </mat-step>

      <mat-step [stepControl]="getAddressFormGroup()">
          <ng-template matStepperIcon="edit">
              <mat-icon class="icon-display">check</mat-icon>
           
            </ng-template>
            <ng-template matStepLabel>Address</ng-template>
            <div  *ngIf="!stepCompleted && registerAs  == '1'" class="step-content-form">

  
   
                      <label class="label-icon">
                          <mat-icon>person</mat-icon>
                          <span>INDIVIDUAL PROPERTY OWNER</span>
                      </label>
                       
                  
                    <div class="Frame32" style="width: 100%; height: 100%;padding-top: 1rem; padding-bottom: 1rem; flex-direction: column; justify-content: flex-start; align-items: center; gap: 32px; display: inline-flex">
                      <div class="Formlabel" style="flex-direction: column; justify-content: flex-start; align-items: flex-start; display: flex">
                      <div class="Label" style="text-align: center; color: rgba(0, 0, 0, 0.87); font-size: 24px; font-family: Roboto; font-weight: 400; line-height: 32.02px; word-wrap: break-word">Address</div>
                      </div>
                      </div>
                      <div class="row" style="justify-content: center;">
                        <mat-radio-group  aria-label="Select an option">
                          <mat-radio-button (change)="radioChangeAddress($event)"  [checked]="true" color="primary"  value="1">Domestic</mat-radio-button>
                          <mat-radio-button (change)="radioChangeAddress($event)" color="primary"  value="2">International</mat-radio-button>
                        </mat-radio-group>
                      </div>
              <form *ngIf="addressType == '1'" [formGroup]="addressOwner">
                <div class="step-body">
                  <div class="row" style="justify-content: center;">
            <div class="controls-container">
          <div #domesticAddress>
            <div class="row">
              <div class="column">
                <mat-form-field  class="mat-form-field-100" appearance="outline" >
                  <mat-label>Owners Street Address</mat-label>
                  <input class="form-outline form-control" matInput formControlName="address1" placeholder="Owners Street Address"
                         >
                          <mat-error *ngIf="this.addressOwner.get('address1')?.errors?.['required'] && (addressOwner.get('address1')?.touched)">Owners Street Address is required</mat-error>
          
              
                </mat-form-field>
          
          
              </div>
          </div>
          <div class="row">
          <div class="column">
            <mat-form-field class="mat-form-field-100" appearance="outline" >
              <mat-label>Apt/Unit/Suite</mat-label>
              <input matInput formControlName="address2" placeholder="Apt/Unit/Suite"
                     >
                     <mat-error *ngIf="this.addressOwner.get('address2')?.errors?.['required'] && (addressOwner.get('address2')?.touched)">Apt/Unit/Suite is required</mat-error>
           
            </mat-form-field>
          </div>
          </div>
            
          <div class="row">
          <div class="column">
          <mat-form-field class="mat-form-field-100" appearance="outline" >
            <mat-label>City</mat-label>
            <input matInput formControlName="city" placeholder="City"
                   >
               
                    <mat-error  *ngIf="this.addressOwner.get('city')?.errors?.['required'] && (addressOwner.get('city')?.touched)">City is required</mat-error>
             
          </mat-form-field>
          
          </div>
          
          <div class="column">
          <mat-form-field class="mat-form-field-100" appearance="outline" >
            <mat-label>State</mat-label>
          
                   <mat-select formControlName="state"  placeholder="State">
                  
                    @for (state of states; track state) {
                      <mat-option [value]="state.id">{{state.name}}</mat-option>
                    }
                  </mat-select>
                    <mat-error *ngIf="this.addressOwner.get('state')?.errors?.['required'] && (addressOwner.get('state')?.touched)">State is required</mat-error>
          </mat-form-field>
         
          </div>
          
          
          <div class="column">
          <mat-form-field class="mat-form-field-100" appearance="outline" >
            <mat-label>Zip Code</mat-label>
            <input type="number" matInput formControlName="zipCode" placeholder="Zip Code"
                   >
                   <mat-error *ngIf="(this.addressOwner.get('zipCode')?.errors?.['pattern'] || this.addressOwner.get('zipCode')?.errors?.['required']) && (addressOwner.get('zipCode')?.touched)">Zip Code is Invalid</mat-error>
                   
          </mat-form-field>
          
          </div>
          </div>
          <div class="row">
          <div class="column">
          <mat-form-field class="mat-form-field-100" appearance="outline" >
          <mat-label>Notes</mat-label>
          <textarea matInput formControlName="note" placeholder="Notes"
                 ></textarea>
          </mat-form-field>
          </div>
          </div>
          </div>
          
          
          
              </div>
                  </div>
                </div>
              </form>
              <div style="width: 50%;">
              <form *ngIf="addressType == '2'" [formGroup]="addressOwnerInternational">
               
                  <div  style="justify-content: center;">
                    <div style="letter-spacing: 20px;">
                      <div #domesticAddress>
                    <div class="row">
                      <div class="column">
                        <mat-form-field  class="mat-form-field-100" appearance="outline" >
                          <mat-label>Addressee's Full Legal name"</mat-label>
                          <input class="form-outline form-control" matInput formControlName="internationalAddressName" placeholder="Addressee's Full Legal name"
                                 >
                                  <mat-error *ngIf="this.addressOwnerInternational.get('internationalAddressName')?.errors?.['required'] && (addressOwnerInternational.get('internationalAddressName')?.touched)">Addressee's Full Legal name" is required</mat-error>
                  
                      
                        </mat-form-field>
                  
                  
                      </div>
                  </div>
  
                  <div class="row">
                    <div class="column">
                      <mat-form-field  class="mat-form-field-100" appearance="outline" >
                        <mat-label>Street Address or Post Office Box Number </mat-label>
                        <input class="form-outline form-control" matInput formControlName="internationalPoBox" placeholder="Street Address or Post Office Box Number "
                               >
                                <mat-error *ngIf="this.addressOwnerInternational.get('internationalPoBox')?.errors?.['required'] && (addressOwnerInternational.get('internationalPoBox')?.touched)">Street Address or Post Office Box Number is required</mat-error>
                
                    
                      </mat-form-field>
                
                
                    </div>
                </div>
  
                <div class="row">
                  <div class="column">
                    <mat-form-field  class="mat-form-field-100" appearance="outline" >
                      <mat-label>City, State, Province and Postal Code</mat-label>
                      <input class="form-outline form-control" matInput formControlName="internationalCityProvinceState" placeholder="City, State, Province and Postal Code"
                             >
                              <mat-error *ngIf="this.addressOwnerInternational.get('internationalCityProvinceState')?.errors?.['required'] && (addressOwnerInternational.get('internationalCityProvinceState')?.touched)">City, State, Province and Postal Code is required</mat-error>
              
                  
                    </mat-form-field>
              
              
                  </div>
              </div>
  
  
              <div class="row">
                <div class="column">
    
                  <mat-form-field class="mat-form-field-100" appearance="outline" >
                    <mat-label>Country</mat-label>
      
                           <mat-select formControlName="internationalCountry"  placeholder="Country">
                          
                            @for (state of country; track state) {
                              <mat-option [value]="state.id">{{state.name}}</mat-option>
                            }
                          </mat-select>

                            <mat-error  *ngIf="this.addressOwnerInternational.get('internationalCountry')?.errors?.['required'] && (addressOwnerInternational.get('internationalCountry')?.touched)">Country required</mat-error>
                      
                  </mat-form-field>
               
                </div>
            </div>
            <div class="row">
              <div class="column">
              <mat-form-field class="mat-form-field-100" appearance="outline" >
              <mat-label>Notes</mat-label>
              <textarea matInput formControlName="note" placeholder="Notes"
                     ></textarea>
              </mat-form-field>
              </div>
              </div>
                      </div>
                    </div>
              
       
                </div>
            
              </form>
              </div>
            </div>
           
              <div  *ngIf="!stepCompleted && (registerAs  == '2' || registerAs  == '3') " style="width: 100%; height: 100%; padding-top: 1rem; padding-bottom: 1rem; flex-direction: column; justify-content: flex-start; align-items: center; gap: 32px; display: inline-flex;">

  
                <div class="step-body" style="width: 60%;">
                  <div *ngIf="registerAs  == '2'"  class="row" style="justify-content: center;">
                    <label class="label-icon">
                      <mat-icon>business</mat-icon>
                      <span>PROPERTY MANAGEMENT COMPANY</span>
                    </label>
                     
                  </div>
                    <div *ngIf="registerAs  == '3'"  class="row" style="justify-content: center;">
                        <label class="label-icon">
                          <p> <mat-icon style="color: #2196F3;">hotel</mat-icon></p>
                          <span>BED & BREAKFAST/ HOTEL / MOTEL</span>
                        </label>
                         
                      </div>
                      <div class="Frame32" style="width: 100%; height: 100%;padding-top: 1rem; padding-bottom: 1rem; flex-direction: column; justify-content: flex-start; align-items: center; gap: 32px; display: inline-flex">
                        <div class="Formlabel" style="flex-direction: column; justify-content: flex-start; align-items: flex-start; display: flex">
                        <div class="Label" style="text-align: center; color: rgba(0, 0, 0, 0.87); font-size: 24px; font-family: Roboto; font-weight: 400; line-height: 32.02px; word-wrap: break-word">Address</div>
                        </div>
                        </div>
                        <div class="row" style="justify-content: center;">
                          <mat-radio-group  aria-label="Select an option">
                            <mat-radio-button (change)="radioChangeAddress($event)"  [checked]="true" color="primary"  value="1">Domestic</mat-radio-button>
                            <mat-radio-button (change)="radioChangeAddress($event)" color="primary"  value="2">International</mat-radio-button>
                          </mat-radio-group>
                        </div>
                <form *ngIf="addressType == '1'" [formGroup]="addressProperty">
                   
              <div class="controls-container">
            <div #domesticAddress>
              <div class="row">
                <div class="column">
                  <mat-form-field  class="mat-form-field-100" appearance="outline" >
                    <mat-label>Street address</mat-label>
                    <input class="form-outline form-control" matInput formControlName="address1" placeholder="Street Address"
                           >
                            <mat-error *ngIf="this.addressProperty.get('address1')?.errors?.['required'] && (addressProperty.get('address1')?.touched)">Owners Street Address is required</mat-error>
            
                
                  </mat-form-field>
            
            
                </div>
            </div>
            <div class="row">
            <div class="column">
              <mat-form-field class="mat-form-field-100" appearance="outline" >
                <mat-label>Apt/Unit/Suite</mat-label>
                <input matInput formControlName="address2" placeholder="Apt/Unit/Suite"
                       >
                       <mat-error *ngIf="this.addressProperty.get('address2')?.errors?.['required'] && (addressProperty.get('address2')?.touched)">Apt/Unit/Suite is required</mat-error>
             
              </mat-form-field>
            </div>
            </div>
              
            <div class="row">
            <div class="column">
            <mat-form-field class="mat-form-field-100" appearance="outline" >
              <mat-label>City</mat-label>
              <input matInput formControlName="city" placeholder="City"
                     >
            </mat-form-field>
            <div *ngIf="this.addressProperty.get('city')?.errors?.['required'] && (addressProperty.get('city')?.touched)">
              <mat-error>City is required</mat-error>
            </div>
            </div>
            
            <div class="column">
            <mat-form-field class="mat-form-field-100" appearance="outline" >
              <mat-label>State</mat-label>
            
                     <mat-select formControlName="state"  placeholder="State">
                    
                      @for (state of states; track state) {
                        <mat-option [value]="state.id">{{state.name}}</mat-option>
                      }
                    </mat-select>
                    <mat-error  *ngIf="this.addressProperty.get('state')?.errors?.['required'] && (addressProperty.get('state')?.touched)">State is required</mat-error>
            
            </mat-form-field>
        
            </div>
            
            
            <div class="column">
            <mat-form-field class="mat-form-field-100" appearance="outline" >
              <mat-label>Zip Code</mat-label>
              <input matInput formControlName="zipCode" placeholder="Zip Code"
                     >

                      <mat-error  *ngIf="this.addressProperty.get('zipCode')?.errors?.['pattern'] && (addressProperty.get('zipCode')?.touched)">Zip Code is Invalid</mat-error>

            </mat-form-field>
         
            
            </div>
            </div>
            <div class="row">
              <div class="column">
                <mat-form-field  class="mat-form-field-100" appearance="outline" >
                  <mat-label>Website url</mat-label>
                  <input class="form-outline form-control" matInput formControlName="websiteUrl" placeholder="Website url"
                         >
                     
              
                </mat-form-field>
          
          
              </div>
          </div>
            <div class="row">
            <div class="column">
            <mat-form-field class="mat-form-field-100" appearance="outline" >
            <mat-label>Notes</mat-label>
            <textarea matInput formControlName="note" placeholder="Notes"
                   ></textarea>
            </mat-form-field>
            </div>
            </div>
            </div>
            
            
            
                </div>
                </form>
            
                <form *ngIf="addressType == '2'" [formGroup]="addressOwnerInternational">
                  <div class="controls-container" style="letter-spacing: 20px;">
                    <div #domesticAddress>
                  <div class="row">
                    <div class="column">
                      <mat-form-field  class="mat-form-field-100" appearance="outline" >
                        <mat-label>Addressee's Full Legal name</mat-label>
                        <input class="form-outline form-control" matInput formControlName="internationalAddressName" placeholder="Addressee's Full Legal name"
                               >
                                <mat-error *ngIf="this.addressOwnerInternational.get('internationalAddressName')?.errors?.['required'] && (addressOwnerInternational.get('internationalAddressName')?.touched)">Addressee's Full Legal name is required</mat-error>
                
                    
                      </mat-form-field>
                
                
                    </div>
                </div>

                <div class="row">
                  <div class="column">
                    <mat-form-field  class="mat-form-field-100" appearance="outline" >
                      <mat-label>Street Address or Post Office Box Number </mat-label>
                      <input class="form-outline form-control" matInput formControlName="internationalPoBox" placeholder="Street Address or Post Office Box Number "
                             >
                              <mat-error *ngIf="this.addressOwnerInternational.get('internationalPoBox')?.errors?.['required'] && (addressOwnerInternational.get('internationalPoBox')?.touched)">Street Address or Post Office Box Number is required</mat-error>
              
                  
                    </mat-form-field>
              
              
                  </div>
              </div>

              <div class="row">
                <div class="column">
                  <mat-form-field  class="mat-form-field-100" appearance="outline" >
                    <mat-label>City, State, Province and Postal Code</mat-label>
                    <input class="form-outline form-control" matInput formControlName="internationalCityProvinceState" placeholder="City, State, Province and Postal Code"
                           >
                            <mat-error *ngIf="this.addressOwnerInternational.get('internationalCityProvinceState')?.errors?.['required'] && (addressOwnerInternational.get('internationalCityProvinceState')?.touched)">City, State, Province and Postal Code is required</mat-error>
            
                
                  </mat-form-field>
            
            
                </div>
            </div>


            <div class="row">
              <div class="column">
    
                <mat-form-field class="mat-form-field-100" appearance="outline" >
                  <mat-label>Country</mat-label>
    
                         <mat-select formControlName="internationalCountry"  placeholder="Country">
                        
                          @for (state of country; track state) {
                            <mat-option [value]="state.id">{{state.name}}</mat-option>
                          }
                        </mat-select>

                          <mat-error  *ngIf="this.addressOwnerInternational.get('internationalCountry')?.errors?.['required'] && (addressOwnerInternational.get('internationalCountry')?.touched)">Country required</mat-error>
                    
                </mat-form-field>
             
              </div>
          </div>
          <div class="row">
            <div class="column">
            <mat-form-field class="mat-form-field-100" appearance="outline" >
            <mat-label>Notes</mat-label>
            <textarea matInput formControlName="note" placeholder="Notes"
                   ></textarea>
            </mat-form-field>
            </div>
            </div>
                    </div>
                  </div>
                </form>
                </div>
        
                </div>

                <div *ngIf="stepCompleted"  class="row">
                  <div class="Frame62" style="width: 1376px; height: 319px; padding-top: 56px; padding-bottom: 56px; flex-direction: column; justify-content: flex-start; align-items: center; gap: 32px; display: inline-flex">
                    <div class="Frame63" style="align-self: stretch; height: 106px; flex-direction: column; justify-content: flex-start; align-items: center; gap: 24px; display: flex">
                      
                        <mat-icon style="color :#2E7D32; font-size: 57px;width: 100px;height: 100px;" color="#2E7D32">check_circle_outline</mat-icon>
               
          
                      
                      <div class="Frame32" style="align-self: stretch; height: 26px; flex-direction: column; justify-content: flex-start; align-items: center; gap: 8px; display: flex">
                        <div class="Formlabel" style="flex-direction: column; justify-content: flex-start; align-items: flex-start; display: flex">
                          <div class="Label" style="color: rgba(0, 0, 0, 0.87); font-size: 24px; font-family: Roboto; font-weight: 500; text-transform: uppercase; line-height: 26px; letter-spacing: 0.46px; word-wrap: break-word">Form submitted succesfully!</div>
                        </div>
                      </div>
                    </div>
                    <div class="Frame33" style="height: 69px; flex-direction: column; justify-content: flex-start; align-items: center; gap: 8px; display: flex">
                      <div class="Formlabel" style="height: 69px; flex-direction: column; justify-content: flex-start; align-items: flex-start; display: flex">
                        <div class="Label" style="align-self: stretch; text-align: center; color: rgba(0, 0, 0, 0.87); font-size: 16px; font-family: Roboto; font-weight: 400; line-height: 22.88px; letter-spacing: 0.17px; word-wrap: break-word">Your information has been submitted and is now being reviewed. We'll get back to you within 72 hours. Sit tight and we'll be in touch soon!<br/></div>
                      </div>
                    </div>
                  </div>
                </div>
      </mat-step>
  </mat-stepper>
  
</div>
<div *ngIf="!stepCompleted" style="position: fixed; bottom: 0;width: 100%;background-color: white;">
<div class="button-stepper-footer">
  <button (click)="openDialog()"  mat-stroked-button mat-button class="button-stepper-cancel">CANCEL<mat-icon>close</mat-icon></button>
  <button  (click)="goBack(stepper)"  *ngIf="stepper.selectedIndex >0" mat-stroked-button mat-button class="button-stepper-back">
    BACK
    <mat-icon>arrow_left_alt</mat-icon>
  </button>
  <button [disabled]="!signatureStepForm.valid"  [ngClass]="{'button-stepper-allow': signatureStepForm.valid ,'button-stepper': signatureStepForm.invalid  }" *ngIf="stepper.selectedIndex == 0" mat-stroked-button mat-button (click)="goForward(stepper)" class="button-stepper-allow">NEXT <mat-icon iconPositionEnd>arrow_right_alt</mat-icon></button>
  <button [disabled]="!selectUserType.valid"  [ngClass]="{'button-stepper-allow': selectUserType.valid ,'button-stepper': selectUserType.invalid  }" *ngIf="stepper.selectedIndex == 1" mat-stroked-button mat-button (click)="goForward(stepper)" class="button-stepper-allow">NEXT <mat-icon iconPositionEnd>arrow_right_alt</mat-icon></button>
  <button [disabled]="!ownerForm.valid"  [ngClass]="{'button-stepper-allow': ownerForm.valid ,'button-stepper': ownerForm.invalid  }" *ngIf="stepper.selectedIndex == 2 && registerAs == '1'" mat-stroked-button mat-button (click)="goForward(stepper)" class="button-stepper-allow">NEXT <mat-icon iconPositionEnd>arrow_right_alt</mat-icon></button>
  <button [disabled]="!managementCompany.valid"  [ngClass]="{'button-stepper-allow': managementCompany.valid ,'button-stepper': managementCompany.invalid  }" *ngIf="stepper.selectedIndex == 2 && registerAs == '2'" mat-stroked-button mat-button (click)="goForward(stepper)" class="button-stepper-allow">NEXT <mat-icon iconPositionEnd>arrow_right_alt</mat-icon></button>
  <button [disabled]="!hotelMotel.valid"  [ngClass]="{'button-stepper-allow': hotelMotel.valid ,'button-stepper': hotelMotel.invalid  }" *ngIf="stepper.selectedIndex == 2 && registerAs == '3'" mat-stroked-button mat-button (click)="goForward(stepper)" class="button-stepper-allow">NEXT <mat-icon iconPositionEnd>arrow_right_alt</mat-icon></button>

  <button [disabled]="!addressOwner.valid"  [ngClass]="{'button-stepper-allow': addressOwner.valid ,'button-stepper': addressOwner.invalid  }" *ngIf="stepper.selectedIndex == 3 && registerAs == '1' && addressType == '1'" mat-stroked-button mat-button (click)="save()" class="button-stepper-allow">SAVE AND REGISTER  <mat-icon iconPositionEnd>arrow_right_alt</mat-icon></button>
  <button [disabled]="!addressProperty.valid"  [ngClass]="{'butaton-stepper-allow': addressProperty.valid ,'button-stepper': addressProperty.invalid  }" *ngIf="stepper.selectedIndex == 3 && registerAs != '1' && addressType == '1'" mat-stroked-button mat-button (click)="save()" class="button-stepper-allow">SAVE AND REGISTER  <mat-icon iconPositionEnd>arrow_right_alt</mat-icon></button>
 
  <button [disabled]="!addressOwnerInternational.valid"  [ngClass]="{'button-stepper-allow': addressOwnerInternational.valid ,'button-stepper': addressOwnerInternational.invalid  }" *ngIf="stepper.selectedIndex == 3 &&  addressType == '2'" mat-stroked-button mat-button (click)="save()" class="button-stepper-allow">SAVE AND REGISTER  <mat-icon iconPositionEnd>arrow_right_alt</mat-icon></button>

</div>
</div>
